import { Link, useRouteError } from 'react-router-dom';
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react';
import { ClipboardIcon } from '@heroicons/react/20/solid';
import { useCopyToClipboard } from 'usehooks-ts';
import { toast } from 'react-toastify';

import { Button } from '../../common/Atoms/Button';

export function ErrorPage() {
  const error = useRouteError();
  const [, copy] = useCopyToClipboard();

  const errorText = (() => {
    try {
      if (typeof error === `string`) return error;
      if (error instanceof Error) {
        const stack = error.stack ? `\n\n${error.stack}` : ``;

        return `${error.message}${stack}`;
      }

      return JSON.stringify(error, null, 2);
    }
    catch {
      return `${error}`;
    }
  })();

  async function handleCopy() {
    try {
      await copy(errorText || ``);
      toast.success(`Copied to clipboard`, { autoClose: 200 });
    }
    catch {
      toast.error(`Failed to copy to clipboard`);
    }
  }

  return (
    <div className={ `bg-gray-200 w-full px-16 md:px-0 min-h-screen flex items-center justify-center` }>
      <div className={ `bg-white border border-gray-200 flex flex-col items-center justify-center px-4 md:px-8 lg:px-24 py-8 rounded-lg shadow-2xl` }>
        <p className={ `text-6xl md:text-7xl lg:text-9xl font-bold tracking-wider text-gray-300` }>{ `Woops!` }</p>
        <p className={ `text-2xl md:text-3xl lg:text-5xl font-bold tracking-wider text-gray-500 mt-4` }>{ `An error has occured` }</p>
        <p className={ `text-gray-500 mt-4 pb-4 border-b-2 text-center` }>{ `Sorry, an unknown error has occured, please refresh and try again. Otherwise contact support.` }</p>
        <p className={ `text-gray-500 mt-4 pb-4 border-b-2 text-center` }>{ `Contact hello@paidnice.com for assistance.` }</p>

        <div className={ `mt-4 max-w-2xl` }>
          <Disclosure>
            { ({ open }) => (
              <div className={ `` }>
                <DisclosureButton className={ `w-full flex items-center justify-between text-left text-sm font-normal text-gray-500 focus:outline-hidden` }>
                  <span className={ `mr-1` }>
                    { `Show error details` }
                  </span>
                  <svg
                    className={ `${open ? `rotate-180` : ``} h-5 w-5 text-gray-400 transition-transform` }
                    viewBox={ `0 0 20 20` }
                    fill={ `currentColor` }
                    aria-hidden={ `true` }
                  >
                    <path
                      fillRule={ `evenodd` }
                      d={ `M5.23 7.21a.75.75 0 011.06.02L10 11.175l3.71-3.944a.75.75 0 011.08 1.04l-4.24 4.51a.75.75 0 01-1.08 0l-4.24-4.51a.75.75 0 01.02-1.06z` }
                      clipRule={ `evenodd` }
                    />
                  </svg>
                </DisclosureButton>
                <DisclosurePanel className={ `px-4 pb-4` }>
                  <div className={ `flex items-center justify-between mb-2` }>
                    <span className={ `text-xs text-gray-500` }>{ `Error payload` }</span>
                    <Button size={ `sm` }
                      color={ `gray` }
                      onClick={ handleCopy }
                      icon={ <ClipboardIcon className={ `h-4 w-4 ml-2` } /> }>
                      { `Copy` }
                    </Button>
                  </div>
                  <pre className={ `text-xs text-gray-800 bg-gray-50 border border-gray-200 rounded-sm p-3 overflow-auto max-h-64 whitespace-pre-wrap break-all` }>
                    { errorText }
                  </pre>
                </DisclosurePanel>
              </div>
            ) }
          </Disclosure>
        </div>
        <Link to={ `/` }>
          <Button className={ `mt-6` }>
            { `Go to dashboard` }
          </Button>
        </Link>
      </div>
    </div>
  );
}
